import React from "react";

import { Box } from "@catchoftheday/cg-components";
import { useTheme } from '@catchoftheday/theme';

import {
  BackgroundTile,
  BackgroundTileProps,
} from "../PrimaryHeader/BackgroundTile";

export const Container: React.FC<BackgroundTileProps> = ({
  children,
  ...props
}) => {
  const theme = useTheme();

  return (
    <BackgroundTile px={["0.875rem", null, "30px"]} {...props}>
      <Box
        maxWidth={theme.maxWidths.default}
        width="100%"
        m="auto"
        height="100%"
      >
        {children}
      </Box>
    </BackgroundTile>
  );
};

export default Container;
